import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'

const SLICE = 'ux'

const REGULAR_TIMEOUT = 4000
const ERROR_TIMEOUT = 6000

// actions
// modals
export const SHOW_MODAL = 'ux/SHOW_MODAL'
export const showModal = (modalType, modalProps) => ({
  type: SHOW_MODAL,
  payload: { modalType, modalProps },
})
export const CLOSE_MODAL = 'ux/CLOSE_MODAL'
export const closeModal = () => ({ type: CLOSE_MODAL })

// creating invite
export const CREATE_MESSAGE = 'ux/CREATE_MESSAGE'
export const createMessage = ({ to_candidate, message_type }) => ({
  type: CREATE_MESSAGE,
  payload: { to_candidate, message_type },
})

// sending invite
export const SEND_MESSAGE = 'ux/SEND_MESSAGE'
export const sendMessage = payload => ({ type: SEND_MESSAGE, payload })

export const IMPORT_CANDIDATES = 'ux/IMPORT_CANDIDATES'
export const importCandidates = (items, project) => ({
  type: IMPORT_CANDIDATES,
  payload: { items, project },
})

// snackbar actions
export const INIT_SNACKS_QUEUE = 'ux/INIT_SNACKS_QUEUE'
export const initSnacksQueue = ({
  id = uuidv4(),
  message,
  type,
  timeout = type === 'error' ? ERROR_TIMEOUT : REGULAR_TIMEOUT,
}) => ({
  type: INIT_SNACKS_QUEUE,
  payload: { id, message, timeout, type },
})

export const SHOW_SNACKBAR = 'ux/SHOW_SNACKBAR'
export const showSnackbar = ({ id, message, timeout, type }) => ({
  type: SHOW_SNACKBAR,
  payload: { id, message, timeout, type },
})

export const CLOSE_SNACKBAR = 'ux/CLOSE_SNACKBAR'
export const closeSnackbar = ({ id, type }) => ({
  type: CLOSE_SNACKBAR,
  payload: { id, type },
})

export const PADDLE_CHECKOUT = 'ux/PADDLE_CHECKOUT'
export const paddleCheckout = payload => ({ type: PADDLE_CHECKOUT, payload })

// reducer
const initialState = {
  modal: null,
  snacks: { success: [], error: [], warning: [], info: [] },
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return R.assoc('modal', action.payload)(state)
    case CLOSE_MODAL:
      return R.assoc('modal', null)(state)
    case SHOW_SNACKBAR:
      return {
        ...state,
        snacks: {
          ...state.snacks,
          [action.payload.type]: [
            ...state.snacks[action.payload.type],
            action.payload,
          ],
        },
      }
    case CLOSE_SNACKBAR:
      return {
        ...state,
        snacks: {
          ...state.snacks,
          [action.payload.type]: R.filter(
            ({ id }) => id !== action.payload.id,
            state.snacks[action.payload.type],
          ),
        },
      }
    default:
      return state
  }
}

export const getModal = R.pathOr({}, [SLICE, 'modal'])

export const getSnacks = R.pathOr(
  { success: [], error: [], warning: [], info: [] },
  [SLICE, 'snacks'],
)
